import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { t } from '@/i18n';
import { useBoard } from '@/api/hooks/board';
import { useGeofences } from '@/api/hooks/catalog';
import { useTripRoute, useTrips } from '@/api/hooks/trips';
import { Card } from '@/components/ui/Card';
import { Checkbox, Select } from '@/components/ui/Field';
import { LazyMap } from '@/components/map/LazyMap';

export function MapPage() {
  const navigate = useNavigate();
  const { snapshot } = useBoard();
  const [tripId, setTripId] = useState('');
  const [showGeofences, setShowGeofences] = useState(true);

  // Последните курсове са достатъчни за повторение на маршрут — историята се търси в „Курсове".
  const trips = useTrips({ perPage: 30, status: ['in_progress', 'completed'] });
  const route = useTripRoute(tripId || undefined, tripId !== '');
  const geofences = useGeofences();

  return (
    <div className="flex h-full min-h-0 flex-col gap-3 p-3 sm:p-4">
      <div className="flex flex-wrap items-center gap-3">
        <h1 className="font-display text-lg font-bold tracking-tight">{t.map.title}</h1>
        <Select
          className="w-64"
          aria-label={t.map.replay}
          value={tripId}
          onChange={(e) => setTripId(e.target.value)}
          placeholder={`${t.map.selectTrip} — ${t.map.vehicles}`}
          options={(trips.data?.items ?? []).map((trip) => ({
            value: trip.id,
            label: `${trip.number} · ${trip.vehicleFleetNo ?? ''} · ${trip.driverName ?? ''}`,
          }))}
        />
        <Checkbox
          label={t.map.geofences}
          checked={showGeofences}
          onChange={(e) => setShowGeofences(e.target.checked)}
        />
        {route.data ? (
          <span className="text-xs text-ink-dim">
            {route.data.points.length} {t.map.positions}
          </span>
        ) : null}
      </div>

      <Card className="min-h-0 flex-1 overflow-hidden p-0">
        <LazyMap
          className="h-full min-h-[24rem] w-full"
          vehicles={snapshot?.vehicles ?? []}
          route={route.data?.points}
          geofences={showGeofences ? geofences.data?.items : undefined}
          onOpenVehicle={(vehicleId) => void navigate({ to: '/vehicles/$vehicleId', params: { vehicleId } })}
        />
      </Card>
    </div>
  );
}
